import { http } from '../http-common';
import { IBalance, IApiResponse } from '../common/types';

export const getBalances = (): Promise<IBalance[] | undefined> => {
	return http.get<IApiResponse<IBalance[]>>('/balances').then((resp)  => {
      const dataResult: IBalance[] | undefined = resp.data.data
      return dataResult
    });
};